module.exports = shared.Scrollmagic;